// Chart.js v2's Legend.fit() sizes a right-position legend's column to its OWN widest label's
// measured text width (itemWidth = labels.boxWidth(40) + fontSize/2(6) + ctx.measureText(text).width,
// legend width = 20 + itemWidth), and DoughnutController derives the ring's outerRadius from
// whatever chart area is left after the legend is laid out. So two doughnuts with identical canvas
// dimensions render different-sized rings whenever their own legend labels differ in length. This
// plugin pins the legend to one shared fixed width (instance-scoped — it patches only the chart it's
// attached to, not Chart.js's Legend prototype), so every chart using it gets the same leftover
// chart area and therefore the same ring size regardless of its own label content.
//
// LEGEND_FIXED_WIDTH was derived from that same itemWidth formula for the longest label currently
// possible across the My Work charts — STATUS_BUCKET_LABELS' "Awaiting Submission / Not Started"
// plus a generous 4-digit count — measured in real Chromium with Chart.js's default legend font
// ("Helvetica Neue"/Helvetica/Arial 12px), which came out to ~257px of item width (~277px of legend
// width); rounded up for headroom. Bump it if a longer label is ever introduced (e.g.
// STATUS_BUCKET_LABELS grows a longer entry, or a project/document-type name legitimately needs
// more room than this leaves).
export const LEGEND_FIXED_WIDTH = 250;

export const fixedLegendWidthPlugin = {
  id: 'fixedLegendWidth',
  beforeLayout: (chart: any) => {
    const legend = chart.legend;
    if (!legend || legend.isHorizontal() || legend.__fixedWidthPatched) return;
    legend.__fixedWidthPatched = true;
    const originalFit = legend.fit.bind(legend);
    legend.fit = () => {
      originalFit();
      legend.width = LEGEND_FIXED_WIDTH;
      legend.minSize.width = LEGEND_FIXED_WIDTH;
    };
  },
};
